export const GET_PATIENT_DETAILS_REQUEST = "PATIENT_DETAILS/GET_PATIENT_DETAILS_REQUEST";
export const GET_PATIENT_DETAILS_SUCCESS = "PATIENT_DETAILS/GET_PATIENT_DETAILS_SUCCESS";
export const GET_PATIENT_DETAILS_FAILURE = "PATIENT_DETAILS/GET_PATIENT_DETAILS_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/PatientDetails/constants.js